import { PageType } from '../components/common';
import { CommonPageOptions, PaymentPageOptions } from './routes.types';

const commonPaymentPageOptions: PaymentPageOptions = {
  withPaymentMethodChanger: true,
  withTitle: true,
  withTimer: true,
  withSideSection: true,
  withBackButton: true,
  withRedirectOnFinishedPayment: true,
  pageType: PageType.Payment,
  showSidePaymentButton: true,
};

const commonPendingPageOptions: PaymentPageOptions = {
  withTitle: true,
  withTimer: true,
  pageType: PageType.Status,
  isTimerHidden: true,
  showSidePaymentButton: false,
};

const commonStatusPageOptions: PaymentPageOptions = {
  withTitle: true,
  pageType: PageType.Status,
};

const commonErrorPageOptions: PaymentPageOptions = {
  isErrorPage: true,
};

export const commonPageOptions: CommonPageOptions = {
  payment: commonPaymentPageOptions,
  pending: {
    timerHidden: {
      ...commonPendingPageOptions,
    },
    timerVisible: {
      ...commonPendingPageOptions,
      isTimerHidden: false,
    },
  },
  success: commonStatusPageOptions,
  status: commonStatusPageOptions,
  failure: commonStatusPageOptions,
  error: commonErrorPageOptions,
};
